import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { py } from '@nib/layout';
import matchSorter from 'match-sorter';
import { colorDarker } from '@nib-components/theme';
import Item from '../Item';
const NoMatchesEl = styled(Item)`
  ${py(4)};
  color: var(--themeColorFg, ${colorDarker});
  cursor: default;
`;
export const NoMatches = _ref => {
  let {
    string
  } = _ref;
  return /*#__PURE__*/_jsxs(NoMatchesEl, {
    children: ["No results match “", string, "”."]
  });
};
NoMatches.propTypes = {
  string: PropTypes.string
};
export const Loading = _ref2 => {
  let {
    string
  } = _ref2;
  return /*#__PURE__*/_jsxs(NoMatchesEl, {
    children: ["Searching for “", string, "”."]
  });
};
Loading.propTypes = {
  string: PropTypes.string
};
export const NonItemMessage = _ref3 => {
  let {
    inputValue,
    loading = false
  } = _ref3;
  return loading ? /*#__PURE__*/_jsx(Loading, {
    string: inputValue
  }) : /*#__PURE__*/_jsx(NoMatches, {
    string: inputValue
  });
};
NonItemMessage.propTypes = {
  inputValue: PropTypes.string,
  loading: PropTypes.bool
};
const OptionsList = _ref4 => {
  let {
    options,
    inputValue,
    getItemProps,
    highlightedIndex,
    selectedItem,
    maxOptionsDisplayed = 5,
    keys = ['value', 'text'],
    loading,
    skipSorting
  } = _ref4;
  const listOptions = skipSorting ? options : matchSorter(options, inputValue, {
    keys
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: listOptions.length === 0 && inputValue.length > 3 ? /*#__PURE__*/_jsx(NonItemMessage, {
      inputValue: inputValue,
      loading: loading
    }) : listOptions.slice(0, maxOptionsDisplayed - 1).map((item, index) => /*#__PURE__*/_jsx(Item, {
      ...getItemProps({
        item,
        index,
        isActive: highlightedIndex === index,
        isSelected: selectedItem === item
      }),
      children: item.text
    }, `option-${item.text}-${index}`))
  });
};
OptionsList.propTypes = {
  maxOptionsDisplayed: PropTypes.number,
  keys: PropTypes.arrayOf(PropTypes.string),
  inputValue: PropTypes.string,
  getItemProps: PropTypes.func,
  highlightedIndex: PropTypes.number,
  selectedItem: PropTypes.object,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    text: PropTypes.string
  })).isRequired,
  loading: PropTypes.bool,
  skipSorting: PropTypes.bool
};
export default OptionsList;